import { useEffect, useMemo, useState } from 'react';
import './NlaItem.css';
import MultioptionButton from '../../../../components/Buttons/MultioptionButton';
import { Dropdowns } from '../../../../components/Dropdowns/Dropdowns';
import Input from '../../../../components/Inputs/Input';
import { useDropdownConfig } from '../../../../contexts/DropdownsContext';
import CheckboxField from '../../../../components/Checkbox/CheckboxField';
import { Popover } from '@mui/material';
import { NlaPositions } from './NlaPositions';
import { getNla, hierarchyUpdate, nlaUpdate, positionsUpdate } from '../../services/NlaService';
import { useSnackBar } from '../../../../hooks/useSnackBar';
import { DialogTrigger } from '../../../../components/Dialog/Dialog';
import DeletePartDialog from './DeletePartDialog';
import { createPart } from '../../services/PartsConfigurationService';
import HierarchyLines from '../../../../TestLine/HierarchyLines';
import useDebounce from '../../../../hooks/useDebounce';
const hColors = ['var(--hierarchy-0)', 'var(--hierarchy-1)', 'var(--hierarchy-2)', 'var(--hierarchy-3)'];

const saveButtons = [
    { label: 'Save and Finish', icon: "icon-save", id: 'save' },
    { label: 'Save and Continue Editing', icon: "icon-save", id: 'save-continue' },
    { label: 'Cancel', icon: "icon-cross", id: 'cancel', type: 'danger' }
];

export const NlaItem = ({ node, tree, idx, replaceInTree, treeBackup, addSubLevel, isNodeOpen, discardNode, showNode, toggleNode, updateNode, dropdownParams, idxNodes, rootPart }) => {

    const { config } = useDropdownConfig(73);


    const [part, setPart] = useState(node.part);
    const [qty, setQty] = useState(node.part.positions.length || 1);
    const [editing, setEditing] = useState(node.part.id === null);
    const [positions, setPositions] = useState(node.part?.positions ?? []);
    const [singlePositionValue, setSinglePositionValue] = useState(node.part.positions[0]?.position || "");
    const [checkbox, setCheckbox] = useState((node.part.positions.length > 1) && !(node.part.positions.every((p, _, a) => a[0].position === p.position)));
    const [nodeSubtreeBackup, setNodeSutreeBackup] = useState(tree.slice(
        idx + 1,
        tree.findIndex((item, index) => index > idx && (item.level <= node.level))
    ));

    const [positionsOpen, setPositionsOpen] = useState(null);

    const { successMsg, warningMsg, infoMsg } = useSnackBar();

    useEffect(()=>{
        setPart(node.part);
        setNodeSutreeBackup(tree.slice(
            idx + 1,
            tree.findIndex((item, index) => index > idx && (item.level <= node.level))
        ));
    },[node])

    const partChange = (part) => {
        setPart(part);
        setQty(part.positions.length || 1);
        setPositions(part.positions);
        setCheckbox((part.positions.length > 1) && !(part.positions.every((p, _, a) => a[0].position === p.position)));
        setSinglePositionValue(part.positions[0]?.position || "");
    }

    const cancelChanges = () => {
        if (node.part.id === null) {
            infoMsg("NLA Level discarded");
            discardNode(node.nodeId)
        } else {
            partChange(node.part);
            setEditing(false);
            replaceInTree(nodeSubtreeBackup, idx, node.level);
        }
    }

    const handleNewPart = (newPart) => {
        getNla(newPart, true, node.nodeId).then(response => {
            if (response.data.responseCode === 200) {
                let completeNewPart = response.data.load.find(n => n.part.id === newPart.id).part;
                partChange(completeNewPart);
                replaceInTree(response.data.load.filter(i => i.part.id !== newPart.id).map(lNode => ({ ...lNode, parentIds: [...node.parentIds, ...lNode.parentIds] })).map(lNode => ({ ...lNode, level: lNode.parentIds.length - 1 })), idx, node.level)
                toggleNode(node);
                // appendToTree(response.data.load, idx);
            }
        })
    }

    const handleSave = async (closeEditing) => {

        if (typeof (part.id) === 'number') {
            let positionsToSave = (qty > 1) ? (
                // [...part.positions.slice(0, qty-1).map(p => ({ ...p, toDelete: false, position: checkbox ? p.position : singlePositionValue })),
                [...Array.from({length: qty}).map((_, j) => ({...({id: part.positions[j]?.id ?? positions[j].id, ...positions[j]}), toDelete: false, position: checkbox ? positions[j].position : singlePositionValue })),
                 ...part.positions.slice(qty).map(p => ({ ...p, toDelete: true }))
                ]

            ) : (part.positions[0] ? [{ ...part.positions[0], position: singlePositionValue, toDelete: false }, ...part.positions.slice(qty).map(p => ({ ...p, toDelete: true }))] : [{ id: null, partId: part.id, position: singlePositionValue, toDelete: false }, ...part.positions.slice(qty).map(p => ({ ...p, toDelete: true }))]);


            // console.warn('*update positions', positionsToSave);
            // return;
            if (node.part.id !== part.id) {
                //unlink previous one (save previous one with parentPartId  null);
                //save current part with parentPartId by the tree



                infoMsg("Saving NLA changes");
                let responsesHierarchy = await hierarchyUpdate([
                    ...(typeof (node.part.id) === 'number' ? [{ ...node.part, parentPartId: null }] : []), { ...part, parentPartId: tree.find(i => i.nodeId === node.parentNode)?.part.id ?? rootPart.id }
                ])
                if (responsesHierarchy.every(r => r.responseCode === 204)) {
                    // successMsg("NLA updated", "NLA hierarchy successfully updated");
                    let updatedPart = responsesHierarchy.find(r => r.load.id === part.id).load;
                    let positionsResponse = await positionsUpdate(positionsToSave);
                    if (positionsResponse.data.responseCode === 204) {
                        if (updatedPart) {
                            updatedPart.positions = positionsResponse.data.load;
                            // console.warn('*saved part & positions:', updatedPart, positionsResponse.data.load);
                            setPositions(positionsResponse.data.load);
                            setPart(updatedPart);
                            updateNode({ ...node, part: { ...updatedPart, positions: positionsResponse.data.load} });
                            successMsg("NLA updated", "NLA hierarchy and positions updated successfully");
                        }
                    } else {
                        warningMsg("Something went wrong saving positions", positionsResponse.data.message || "");
                    }
                    // let responsesPositions = await 
                } else {
                    warningMsg("Something went wrong", responsesHierarchy.find(r => r.repsonseCode !== 204)?.message || "");
                }
                // nlaUpdate(
                //     positionsToSave,
                //     [...(typeof (node.part.id) === 'number' ? [{ ...node.part, parentPartId: null }] : []), { ...part, parentPartId: treeBackup.find(i => i.nodeId === node.parentNode)?.part.id }],
                //     node.part.positions
                // ).then(response => {
                //     if (response.data.responseCode === 200) {
                //         successMsg("NLA updated", "NLA hierarchy and positions updated sucessfully");
                //         updateNode({ ...node, part: { ...part, positions: response.data.savedPositions } });
                //         setNodeSutreeBackup(tree.slice(
                //             idx + 1,
                //             tree.findIndex((item, index) => index > idx && (item.level <= node.level))
                //         ));
                //     } else {
                //         warningMsg("Something went wrong", "Could not update the NLA hierarchy");
                //     }
                // });

            } else {
                infoMsg("Saving positions");
                let positionsResponse = await positionsUpdate(positionsToSave);
                if (positionsResponse.data.responseCode === 204) {
                    updateNode({ ...node, part: { ...part, positions: positionsResponse.data.load } });
                    setPositions(positionsResponse.data.load);
                    setPart(prev => ({...prev, positions: positionsResponse.data.load}));
                    // console.warn('*saved positions:', positionsResponse.data.load);
                    successMsg("NLA updated", "NLA positions updated sucessfully");
                } else {
                    warningMsg("Something went wrong saving positions", positionsResponse.data.message || "");
                }
                // only save positions
                // let positionsToSave = qty > 1 ? (checkbox ? positions.map(p => ({ ...p, partId: part.id, id: null })) : Array.from({ length: qty }).map(_ => ({ id: null, partId: part.id, position: singlePositionValue }))) : [{ id: null, partId: part.id, position: singlePositionValue }];
                // nlaUpdate(
                //     positionsToSave,
                //     [],
                //     node.part.positions
                // ).then(response => {
                //     if ((response.data.responseCode < 300) && (response.data.responseCode > 199)) {
                //         successMsg("NLA updated", "NLA positions updated sucessfully");
                //         updateNode({ ...node, part: { ...part, positions: response.data.savedPositions } });
                //     } else {
                //         warningMsg("Something went wrong", "Could not update the NLA hierarchy");
                //     }
                // });
            }
            if (closeEditing) setEditing(false);
        } else {
            infoMsg("Select a Part Number for this Level");
        }
    }
    // return(JSON.stringify(node.part.partNumber));

    //debounce quantity
    const debouncedQty = useDebounce(qty, 500);

    useEffect(() => {
        setPositions(prev => {
            return [
                ...part.positions.slice(0, qty).map((partPos, j) => ({ ...partPos, position: prev[j]?.position || "" })),
                ...Array.from({ length: qty - part.positions.length }).map((_, j) => ({ id: null, partId: part.id, position: "" }))
            ]
        });
        if (qty < 2) {
            setCheckbox(false);
        }
        // setPositions(Array.from({ length: qty }).map(_ => ({ id: null, partId: part.id, position: "" })));
        // setPositions(prevPositions => {
        //     if (qty > prevPositions.length) {
        //         // Append new objects to reach the desired length
        //         return [
        //             ...prevPositions.map(p => ({ ...p, id: null })),
        //             ...Array.from({ length: qty - prevPositions.length }).map(() => ({
        //                 id: null,
        //                 partId: part.id,
        //                 position: ""
        //             }))
        //         ];
        //     } else {
        //         // Truncate the array to match the desired length
        //         return prevPositions.slice(0, qty).map(p => ({ ...p, id: null }));
        //     }
        // });
        // if (qty < 2) {
        //     setCheckbox(false);
        // }
    }, [debouncedQty]);



    const handleDelete = () => {
        infoMsg("Removing part")
        createPart({ ...node.part, parentPartId: null }).then(response => {
            if (response.data.responseCode === 204) {
                successMsg("Part removed from the NLA hierarchy");
                discardNode(node.nodeId);
            } else {
                warningMsg(response.data.message || "Something went wrong");
            }
        });
    }

    const dropdwnPreSelect = useMemo(() => {
        return { id: node.part.id, part_number: node.part.partNumber }
    }, [node]);

    //hierarchy siblings sharing any parent node (for hierarchy lines computation)
    let siblings = useMemo(() =>
        tree.slice(idx + 1).filter(n => node.parentIds.includes(n.parentNode)).map(n => n.level)
        , [tree, idx, node]
    );

    // const hasChildren = useMemo(()=>)

    return (<div className='nla-item-component' onClick={() => toggleNode(node)} style={{ position: "relative", display: showNode(node) ? 'grid' : 'none' }}>
        <div style={{ position: "absolute", top: 0, left: 0, zIndex: 1, fontSize: "0.4rem", background: "#00FFFF55", pointerEvents: "none" }}>
            {/* {JSON.stringify(nodeSubtreeBackup)} */}
        </div>
        {/* tree.slice(idx + 1).some(n => (n.level-1 === hl) && (node.parentIds.includes(n.parentNode)))  */}
        {
            Array.from({ length: node.level }, (_, i) => i).map(hl => (hl === node.level - 1 || siblings.some(nl => nl - 1 === hl)) &&
                <>
                    {/* <b style={{color: ((hl < nlaFlatTree[idx + 1]?.level) || (nlaItem.level === hl + 1)) ? "blue" : "red"}}>{hl}</b> */}
                    {/* {(((hl < nlaFlatTree[idx + 1]?.level) || (nlaItem.level === hl + 1))) && */}
                    {/* {(sliceUntilCondition(nlaFlatTree, idx,i => (i.level < nlaItem.level) ).some(i => (hl+1 === i.level))) && */}
                    {/* {nlaFlatTree.slice(idx).some((i, j) => ((i.level > nlaItem.level) ? (hl+1 === i.level) : false)) && */}
                    {
                        <HierarchyLines
                            zIndex={0}
                            noChild={(hl === node.level - 1)}
                            idx={idx} totalLength={tree.length}
                            initialTop={63}
                            depth={hl}
                        />
                    }
                </>
            )
        }
        <div className='properties'>
            <div className='dot' style={{ backgroundColor: hColors[node.level % hColors.length], marginLeft: `${(node.level) * 0.87}rem` }}>

            </div>
            <div className='prop'>
                <span>PN</span>
                {!editing ? <b>{part.partNumber}</b> : <div className='dropdown-contianer' onClick={(e) => e.stopPropagation()}>
                    <Dropdowns data={config} optionLabel="part_number" hideLabel preSelectOption={dropdwnPreSelect} onOptionSelect={handleNewPart} parameters={dropdownParams} />
                </div>
                }
            </div>
            <div className='prop qty'>
                <span>Quantity</span>
                {!editing ? <b className={`${qty > 1 ? 'square' : ''}`} style={qty > 1 ? { backgroundColor: hColors[node.level % hColors.length] } : {}}>{qty || "--"}</b> :
                    <Input onClick={(e) => e.stopPropagation()} value={qty} onChange={(e) => setQty(e.target.value)} isNumeric />
                }
            </div>
            <div className='prop nla'>
                {qty > 1 && <div className='check-container' onClick={(e) => e.stopPropagation()}>

                    <CheckboxField disabled={!editing} checked={checkbox} onChange={e => setCheckbox(e)}>Multiple Positions</CheckboxField>
                </div>}
                {!checkbox ?
                    <><span>NLA Position</span>
                        {!editing ? <b>{singlePositionValue || "--"}</b> : <Input onClick={(e) => e.stopPropagation()} value={singlePositionValue} onChange={(e) => setSinglePositionValue(e.target.value)} />}</> : <>

                        <button onClick={(e) => { e.stopPropagation(); setPositionsOpen(e.currentTarget) }} className="mid-size filled">
                            NLA Positions
                        </button>
                        <Popover anchorOrigin={{
                            vertical: 'center',
                            horizontal: 'right',
                        }}
                            transformOrigin={{
                                vertical: 'center',
                                horizontal: 'left',
                            }} onClose={(e) => { e.stopPropagation(); setPositionsOpen(null) }} open={Boolean(positionsOpen)} anchorEl={positionsOpen} >
                            <NlaPositions positions={positions} updatePositions={setPositions} editing={editing} onClose={() => setPositionsOpen(null)} partNumber={part.partNumber}></NlaPositions>
                        </Popover>
                    </>}
            </div>
        </div>
        <div className='actions' onClick={(e) => e.stopPropagation()}>
            {!editing && <>
                <button onClick={() => addSubLevel({ idx, level: node.level + 1, parentNode: node.nodeId, parentIds: [...node.parentIds, node.nodeId] })} className='transparent'>
                    <span>NLA Sublevel</span>
                    <i className='icon-add-aircraft'></i>
                </button>
                <i className='icon-edit' onClick={() => setEditing(true)}></i>
                {typeof (node.part.id) === 'number' ? <DialogTrigger dialogContent={{
                    component: DeletePartDialog, props: {
                        item: { "PN": node.part.partNumber, "Quantity": node.part.positions.length || 1 },
                        message: "Are you sure you want to remove this part from the NLA hierarchy?",
                        onDelete: handleDelete
                    }
                }}>
                    <i className='icon-delete-new'></i>
                </DialogTrigger> :
                    <i className='icon-delete-new' onClick={() => discardNode(node.nodeId)}></i>
                }
                <i onClick={()=>toggleNode(node)} className={`${ tree[idx+1]?.level > node.level ? `icon-arrow-down ${isNodeOpen(node) ? 'rotate': ''}` : `icon-hyphen`}`}>

                </i>

            </>}
            {editing && <MultioptionButton buttonCallbacks={{
                'save': () => handleSave(true),
                'save-continue': () => handleSave(false),
                'cancel': () => cancelChanges()
            }} buttons={saveButtons}></MultioptionButton>}

        </div>

        {/* <div className='hierarchy'> */}


        {/* </div> */}

    </div>);
}


